export const COGNITO_ERROR = {
  ja: {
    'Password did not conform with policy: Password must have symbol characters': 'パスワードに誤りがあります。パスワードには記号文字を使用する必要があります。',
    'Password did not conform with policy: Password must have uppercase characters': 'パスワードに誤りがあります。パスワードには大文字を使用する必要があります。',
    'Attributes did not conform to the schema: custom:organization: String must be no shorter than 2 characters\n': '部署名には2文字以上入力する必要があります。',
    'A client attempted to write unauthorized attrivute': 'カスタム属性に書き込み出来ません。',
    'Account recovery requires verified contact information': 'アカウントの復元には確認済みの連絡先情報が必要です。管理者に連絡して下さい。',
    'An account with the given email already exists.': 'そのメールアドレスは既に存在します。別のメールアドレスを入力して下さい。',
    'Attempt limit exceeded, please try after some time.': '試行制限を超過しました。しばらくしてからもう一度お試しください',
    'Back to Sign In': 'サインイン画面に戻る',
    'Confirm Sign Up': 'サインアップの確認',
    'Confirm': '確認',
    'Confirmation Code': '確認コード',
    'Create a new account': 'アカウントの新規登録',
    'Create Account': '新規登録',
    'Create account': '新規登録',
    'CUSTOM_AUTH is not enabled for the client.': 'パスワードは必須です', // 本来の意味とは異なるが、パスワード未入力時に発生するのでこの訳としている
    'Email': 'メールアドレスを入力して下さい。',
    'Email Address *': 'メールアドレス *必須',
    'Enter your code': '確認コードを入力してください。 ',
    'Enter your password': 'パスワードを入力してください。',
    'Enter your email address': 'メールアドレスを入力してください。',
    'Enter your username': 'ユーザーIDを入力してください。',
    'Forgot your password?': 'パスワードをお忘れの方 ',
    'Have an account?': 'アカウント登録済みの方',
    'Sign in': 'サインイン',
    'Hello': 'こんにちは ',
    'Incorrect username or password.': 'ユーザーIDまたはパスワードが異なります。正しく入力してください。',
    'Invalid password format': 'パスワードのフォーマットが不正です。 (8文字以上の大文字小文字を含む英数字)',
    'Invalid phone number format': '不正な電話番号フォーマットです。 電話番号は次のフォーマットで入力してください: +12345678900',
    'Invalid verification code provided, please try again.': '指定された確認コードが無効です。もう一度お試しください。',
    'Lost your code?': 'コードを紛失した方 ',
    'No account?': 'アカウント未登録の方',
    'Password attempts exceeded': 'パスワード試行回数が超過しました',
    'Password does not conform to policy: Password must have lowercase characters': 'パスワードには小文字を含めてください (8文字以上の大文字小文字を含む英数字)', // 適宜修正
    'Password does not conform to policy: Password must have numeric characters': 'パスワードには数字を含めてください (8文字以上の大文字小文字を含む英数字)', // 適宜修正
    'Password does not conform to policy: Password must have uppercase characters': 'パスワードには大文字を含めてください (8文字以上の大文字小文字を含む英数字)', // 適宜修正
    'Password does not conform to policy: Password not long enough': 'パスワードは8文字以上を入力してください (8文字以上の大文字小文字を含む英数字)', // 適宜修正
    'Password *': 'パスワード *必須',
    'Password': 'パスワードを入力してください。',
    'Password reset required for the user': 'パスワードがリセットされました。管理者に連絡して下さい。',
    'Phone Number *': '電話番号',
    'Resend Code': '確認コードの再送',
    'Reset password': 'パスワードのリセット',
    'Reset your password': 'パスワードのリセット',
    'Send Code': 'コードの送信',
    'Sign in to your account': '発注管理ツールにサインイン',
    'Sign In': 'サインイン',
    'Sign Out': 'サインアウト',
    'User already exists': '入力したユーザー(Email)は既に存在します。別にユーザー(Email)を入力して下さい。',
    'User does not exist': 'ユーザーが登録されていません。管理者にユーザー登録を依頼して下さい。',
    'User is disabled.': 'このユーザーは無効です。',
    'User is not confirmed.': 'ユーザー(Email)は検証されていません。管理者に連絡して下さい。',
    'Username cannot be empty': 'ユーザーIDは必須入力です。',
    'Username *': 'ユーザーID (メールアドレス) *必須',
    'Username': 'ユーザーIDを入力してください。',
    'Username/client id combination not found.': 'ユーザーIDが見つかりません。',
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": 'パスワードは8文字以上、英大文字・英小文字・記号・数字を含んだ文字列を指定してください', // 適宜修正。本来の意味とは異なるがこれで明示している。
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[S]+.*[S]+$": 'パスワードは8文字以上、英大文字・英小文字・記号・数字を含んだ文字列を指定してください', // 適宜修正。本来の意味とは異なるがこれで明示している。
    'Password does not conform to policy: Password must have symbol characters': 'パスワードは8文字以上、英大文字・英小文字・記号・数字を含んだ文字列を指定してください',
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": 'パスワードは8文字以上、英大文字・英小文字・記号・数字を含んだ文字列を指定してください',
  },
};

